import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Paper,
  Stack,
  Typography,
  styled,
} from "@mui/material";
import React, { useRef, useState } from "react";
import Preview1 from "./Preview1";
import ReactToPrint from "react-to-print";
import Carousel from "react-material-ui-carousel";
import Preview2 from "./Preview2";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import Preview3 from "./Preview3";
import Preview4 from "./Preview4";
import Preview5 from "./Preview5";
export const Colors = styled(Typography)({
  width: "40px",
  height: "40px",
  borderRadius: "50%",
});
const ColorsArr = [
  "#4EAF51",
  "#AF4E4E",
  "#A74EAF",
  "#5C4EAF",
  "#4E8CAF",
  "#4EAFAF",
  "#4EAF92",
  "#7FAF4E",
  "#AF9A4E",
  "#AF714E",
  "#AF9F4E",
];
const ButtonPrint = styled(Button)({
  backgroundColor: "#4caf50",
  fontWeight: "bold",
  borderRadius: "5px",
  color: "white",
  textTransform: "none",
  marginLeft: "10px",
  boxShadow: "0px 2px 3px rgb(161, 161, 161)",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "#4caf50",
  },
});
function Item(props) {
  return <>{props.item}</>;
}

function BillPreviewUpdated({
  title,
  open,
  onClose,
  bill,
  fivePercent = "",
  onQuotation = "",
  sellItem = "",
  returnBillPrint = "",
  onSale = "",
}) {
  const form1 = useRef();
  const form2 = useRef();
  const form3 = useRef();
  const form4 = useRef();
  const form5 = useRef();

  const [state, setState] = useState({
    selectedColor: "#4EAF51",
  });
  const [activeIndex, setActiveIndex] = useState(0);

  const handleNext = () => {
    if (activeIndex < items.length - 1) {
      setActiveIndex((prevIndex) => prevIndex + 1);
    }
  };

  const handlePrev = () => {
    if (activeIndex > 0) {
      setActiveIndex((prevIndex) => prevIndex - 1);
    }
  };
  const changeColor = (color) => {
    setState((prev) => ({ ...prev, selectedColor: color }));
  };
  const PrintPreview1 = React.forwardRef((props, ref) => (
    <Box spacing={3} sx={{ mt: 2, padding: 3 }} ref={ref}>
      <Preview1
        selectedColor={state.selectedColor}
        bill={bill}
        fivePercent={fivePercent}
      />
    </Box>
  ));
  const PrintPreview2 = React.forwardRef((props, ref) => (
    <Box spacing={3} sx={{ mt: 2, padding: 3 }} ref={ref}>
      <Preview2
        selectedColor={state.selectedColor}
        bill={bill}
        fivePercent={fivePercent}
      />
    </Box>
  ));
  const PrintPreview3 = React.forwardRef((props, ref) => (
    <Box spacing={3} sx={{ mt: 2, padding: 3 }} ref={ref}>
      <Preview3
        selectedColor={state.selectedColor}
        bill={bill}
        fivePercent={fivePercent}
      />
    </Box>
  ));
  const PrintPreview4 = React.forwardRef((props, ref) => (
    <Box spacing={3} sx={{ mt: 2, padding: 3 }} ref={ref}>
      <Preview4
        selectedColor={state.selectedColor}
        bill={bill}
        fivePercent={fivePercent}
      />
    </Box>
  ));
  const PrintPreview5 = React.forwardRef((props, ref) => (
    <Box spacing={3} sx={{ padding: 3 }} ref={ref}>
      <Preview5
        selectedColor={state.selectedColor}
        bill={bill}
        fivePercent={fivePercent}
      />
    </Box>
  ));
  const items = [
    <PrintPreview1 ref={form1} />,
    <PrintPreview2 ref={form2} />,
    <PrintPreview3 ref={form3} />,
    <PrintPreview4 ref={form4} />,
    <PrintPreview5 ref={form5} />,
  ];
  const printReciept = async (type) => {
    if (bill.printQuote == "true") {
      // setLoading(true);
      if (sellItem == true) {
        await onQuotation();
        // setLoading(false);
        // print(type, "Quotation");
        onClose();
      }
    } else {
      if (sellItem == true) {
        await onSale();
        // print(type);
        onClose();
      } else if (sellItem == false) {
        if (returnBillPrint == "true") {
          // print("returnBillPrint");
          onClose();
        } else {
          // print(type);
          onClose();
        }
      }
    }
  };
  return (
    <div>
      {" "}
      <Dialog
        title={title}
        fullWidth
        maxWidth="auto"
        open={open}
        onClose={onClose}
        style={{ minHeight: "500px" }}>
        <DialogContent dividers={scroll === "paper"}>
          <ButtonPrint onClick={onClose} size="small">
            Go Back
          </ButtonPrint>
          <ReactToPrint
            trigger={() => <ButtonPrint size="small">Go TO Print</ButtonPrint>}
            onAfterPrint={() => printReciept("English")}
            content={() =>
              activeIndex === 0
                ? form1?.current
                : activeIndex === 1
                ? form2?.current
                : activeIndex === 2
                ? form3?.current
                : activeIndex === 3
                ? form4?.current
                : activeIndex === 4 && form5?.current
            }
          />
          <Stack
            direction={"row"}
            justifyContent={"center"}
            alignItems={"center"}
            spacing={1}>
            <Typography sx={{ fontSize: "18px", fontWeight: "semi-bold" }}>
              Choose Color:
            </Typography>
            <Stack direction={"row"}>
              {ColorsArr.map((item) => (
                <Colors
                  sx={{ background: item }}
                  onClick={() => changeColor(item)}
                />
              ))}
            </Stack>
          </Stack>
          <Carousel
            autoPlay={false}
            index={activeIndex}
            indicators={false}
            indicatorContainerProps={{
              style: {
                display: "none",
              },
            }}
            onChangeIndex={setActiveIndex}
            NextIcon={<KeyboardArrowRightIcon onClick={handleNext} />}
            PrevIcon={<KeyboardArrowLeftIcon onClick={handlePrev} />}>
            {items.map((item, i) => (
              <Stack id="content-to-print">
                <Item key={i} item={item} />
              </Stack>
            ))}
          </Carousel>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default BillPreviewUpdated;
